export const SecuritySection = () => {
  const lastScan: string = new Date().toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const security = {
    lastScan,
    malwareDetected: "None",
    firewall: "Active",
    backupStatus: "Daily",
  };

  return (
    <section className="rounded-2xl border bg-card p-6 shadow-sm">
      <h2 className="mb-4 text-xl font-semibold">Security</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Object.entries(security).map(([label, value]) => (
          <div
            key={label}
            className="flex flex-col rounded-lg border p-4 bg-muted/30"
          >
            <span className="text-sm text-muted-foreground capitalize">
              {label.replace(/([A-Z])/g, " $1")}
            </span>
            <span className="text-base font-medium">{value}</span>
          </div>
        ))}
      </div>
    </section>
  );
};
